type Comparable = number | string | boolean | Date;

/**
 * Orders by ascending
 * @source Original location: UiUtils.ts.backup line 2216
 */
export const orderBy = <T extends Comparable>(a: T, b: T) => {
	if (typeof a === 'string' && typeof b === 'string') {
		return a.localeCompare(b, 'en', {
			ignorePunctuation: true,
			sensitivity: 'accent',
		});
	}

	if (a > b) {
		return 1;
	}

	if (a < b) {
		return -1;
	}

	return 0;
};

/**
 * Orders by descending
 * @source Original location: UiUtils.ts.backup line 2233
 */
export const orderByDescending = <T extends Comparable>(a: T, b: T) => {
	if (typeof a === 'string' && typeof b === 'string') {
		return b.localeCompare(a, 'en', {
			ignorePunctuation: true,
			sensitivity: 'accent',
		});
	}

	if (a < b) {
		return 1;
	}

	if (a > b) {
		return -1;
	}

	return 0;
};
